import { render, staticRenderFns } from "./IOSInstallBanner.vue?vue&type=template&id=1ea9e2a2&scoped=true&"
import script from "./IOSInstallBanner.vue?vue&type=script&lang=js&"
export * from "./IOSInstallBanner.vue?vue&type=script&lang=js&"
import style0 from "./IOSInstallBanner.vue?vue&type=style&index=0&id=1ea9e2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea9e2a2",
  null
  
)

export default component.exports